import { GeoJSON } from 'ol/format';
import { getInitials } from '@/util';
const GeoDkApiBaseUrl = 'https://api-test-api.services.geodanmark.nu/';

export default {
  getMe (token) {
    return fetch(`${GeoDkApiBaseUrl}brugere/mig`, {
      method: 'GET',
      headers: new Headers({
        'Authorization': 'Bearer ' + token,
      }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (resp) {
        if (resp.errors && resp.errors[0].title === 'Authorization has been denied for this request.') {
          localStorage.removeItem('token');
          throw new Error('Bruger har blivet logget ud. Log ind på nyt.');
        }
        const { data } = resp;
        const attr = data.attributes;
        const user = {
          userName: attr.navn,
          initials: getInitials(attr.navn),
          token,
          allKommuner: true,
        };
        localStorage.setItem('token', user.token);
        return user;
      })
      .catch(error => {
        localStorage.removeItem('token');
        throw error;
      });
  },
  getGeoDkObjektById (geodkId, token) {
    return fetch(`${GeoDkApiBaseUrl}geodkobjekter/${geodkId}`,
      {
        method: 'GET',
        headers: { Authorization: 'Bearer ' + token },
      }
    )
      .then(response => {
        return response.json();
      })
      .then(resp => {
        if (resp.errors) {
          throw new Error(resp.errors[0].title);
        }
        const { data } = resp;
        var f = new GeoJSON().readFeature(data.attributes.geometri);
        f.setProperties({ ...data.attributes.egenskaber, geoDkId: data.id });
        return f;
      });
  },
  getGeoDkObjektByIdRaw (geodkId, adapterOptions, token) {
    return fetch(`${GeoDkApiBaseUrl}geodkobjekter/${geodkId}`,
      {
        method: 'GET',
        headers: { Authorization: 'Bearer ' + token },
      }
    )
      .then(response => {
        return response.json();
      });
  },
  getGeoDkObjektByBbox (bbox, token) {
    return fetch(
      `${GeoDkApiBaseUrl}geodkobjekter/?filter[objekttyper]=6&bbox=${bbox.join(',')}`,
      {
        method: 'GET',
        headers: { Authorization: 'Bearer ' + token },
      }
    )
      .then(response => {
        return response.json();
      })
      .then(resp => {
        if (resp.errors) {
          throw new Error(resp.errors[0].title);
        }
        const { data } = resp;
        if (data && data.length) {
          var geodkobj = data[0];
          var f = new GeoJSON().readFeature(geodkobj.attributes.geometri);
          f.setProperties({ ...geodkobj.attributes.egenskaber, geoDkId: geodkobj.id });
          return f;
        }
      });
  },
  getGeoDkObjektByBboxPaged (bbox, token, page = 0, features = []) {
    return new Promise((resolve, reject) => fetch(
      `${GeoDkApiBaseUrl}geodkobjekter/?filter[objekttyper]=6&bbox=${bbox.join(',')}&page=${page}`,
      {
        method: 'GET',
        headers: { Authorization: 'Bearer ' + token },
      }
    )
      .then(response => {
        if (response.status !== 200) {
          throw new Error(`${response.status}: ${response.statusText}`);
        }
        response.json().then(data => {
          const d = data.data;
          if (d && d.length) {
            for (var i = 0; i < d.length; i++) {
              var geodkobj = d[i];
              var f = new GeoJSON().readFeature(geodkobj.attributes.geometri);
              f.setProperties({ ...geodkobj.attributes.egenskaber, geoDkId: geodkobj.id });
              f.setId(`geodkid.${geodkobj.id}`);
              features.push(f);
            }
          }
          if (d && d.length === 50) {
            // progress && progress(features);
            page++;
            this.getGeoDkObjektByBboxPaged(bbox, token, page, features).then(resolve).catch(reject);
          } else {
            resolve(features);
          }
        }).catch(reject);
      }).catch(reject));
  },
};
